export const ru = {
    'phrases-cell-title': 'Фразы',
    'shows-cell-title': 'Число показов'
};
